import './App.css'
import '@aws-amplify/ui-react/styles.css';
import MapWindow from './components/MapWindow';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {

  useEffect(() => {
    // Log navigator to get device and browser details:
    console.warn('User Agent:', navigator);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MapWindow />} />
        <Route path="/new" element={<MapWindow />} />
        <Route path="/place/:placeId" element={<MapWindow />} />
        <Route path="/user" element={<MapWindow />} />
        <Route path="/user/legal" element={<MapWindow />} />
        <Route path="/user/report" element={<MapWindow />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
